import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { AttendantService } from '../../services/attendant.service';
import { FilasService } from '../../services/filas.service';
import { IAttendant } from '../../data/lista.interface';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-tab-atendente',
  templateUrl: './tab-atendente.component.html',
  styleUrls: ['./tab-atendente.component.scss']
})
export class TabAtendentesComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoAtendentes = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() queueAtendentes: IAttendant[] = [];
  @Input() companyId?: string;
  @Input() queuePartnerId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  addAttendantOpen = false;

  formGroup = new UntypedFormGroup({
    attendantSelected: new UntypedFormControl([])
  });

  attendantOptions: IAttendant[] = [];

  constructor(
    private readonly router: Router,
    private readonly attendantService: AttendantService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly queueService: FilasService,
    private readonly sessionService: SessionService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.getActivesAttendants();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['queueAtendentes'] && !changes['queueAtendentes'].firstChange) {
      this.getActivesAttendants();
    }
  }

  public abrirEmNovaAba(atendenteId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/atendentes/editar/${atendenteId}`]));

    window.open(url, '_blank');
  }

  getActivesAttendants(): void {
    const isAdmOlive = this.sessionService.getSession().role === ERoleAdminString.Admin;
    const userPartnerId = this.sessionService.getSession().partnerId;
    const queueId = this.activatedRoute.snapshot.paramMap.get('id')!;

    this.queueService.listAttendantsInQueue(queueId, { pageNumber: 0, pageSize: 9999, orderBy: EOrdenacao.AlfabeticaAZ }).subscribe((queueRes) => {
      const inQueueIds = new Set((queueRes.data ?? []).map(a => a.id));

      if (!isAdmOlive && userPartnerId) {
        this.attendantService.getActiveAttendants().subscribe((response) => {
          this.attendantOptions = response.data.filter(a => !inQueueIds.has(a.id));
        });
      } else {
        this.attendantService.getActiveAttendantsByPartner(this.queuePartnerId!).subscribe((response) => {
          this.attendantOptions = response.data.filter(a => !inQueueIds.has(a.id));
        });
      }
    });
  }

  public updateQueueAttendants(): void {
    this.recarregarListagem.emit();
  }

  public addAttendant(): void {
    const attendantSelected = this.formGroup.get('attendantSelected')?.value;

    if (attendantSelected.length === 0) return;

    const queueId = this.activatedRoute.snapshot.paramMap.get('id')!;

    this.queueService.addAttendantsToQueue(queueId, attendantSelected).subscribe({
      next: () => {
        this.updateQueueAttendants();
        this.formGroup.reset();
        this.addAttendantOpen = false;
      },
      error: () => {
        this.toastService.toast('Erro ao adicionar atendente na fila. Tente novamente.', undefined);
      }
    });
  }

  public removeAttendant(attendantId: string): void {
    const queueId = this.activatedRoute.snapshot.paramMap.get('id')!;

    this.queueService.removeAttendantFromQueue(queueId, attendantId).subscribe(() => {
      this.updateQueueAttendants();
    });
  }
}
